import React from 'react';
import { motion } from 'framer-motion';
export function ProductShowcase() {
  return <section className="py-20 bg-navy text-white overflow-hidden" data-id="element-177">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-178">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-179">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-180">
            <h2 className="font-heading text-4xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-181">
              Presentamos:
              <br data-id="element-182" />
              <span className="text-orange" data-id="element-183">CÓDIGO CALMA</span>
            </h2>
            <div className="w-20 h-2 bg-orange mb-8 rounded-full" data-id="element-184"></div>

            <p className="text-xl md:text-2xl font-medium mb-6 leading-relaxed" data-id="element-185">
              El primer método táctico diseñado 100% para la realidad del
              trabajador en Chile.
            </p>

            <p className="text-lg text-gray-300 leading-relaxed" data-id="element-186">
              Esto no es autoayuda genérica importada de Estados Unidos. Es un
              manual de operaciones para tu sistema nervioso, construido con la
              realidad chilena en mente.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-187">
            <div className="absolute inset-0 bg-orange/20 blur-3xl rounded-full transform scale-90" data-id="element-188"></div>
            <img src="https://cdn.magicpatterns.com/uploads/ghtQhQqD8kap6yc3RFyP6Z/codigo_calma_hero.png" alt="Código Calma Bundle" className="relative z-10 w-full h-auto rounded-xl shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-189" />
          </motion.div>
        </div>
      </div>
    </section>;
}